import { actionTypes } from '../../../controller';
import { SocketTypeEnums } from '../../../../lib/enums';

const {
	CONVERSATION_COMMAND_GET,
	CONVERSATION_TEXT_SIZE_COMMAND_UPDATE,
	CONVERSATION_NORMAL_REPLY_COMMAND_CREATE,
	CONVERSATION_QUICK_PATH_COMMAND_CREATE,
	CONVERSATION_SMART_REPLY_COMMAND_CREATE,
	CONVERSATION_COMMAND_CLOSE,
	CONVERSATION_SCORE_COMMAND_UPDATE,
	CONVERSATION_SESSION_COMMAND_CLEAR,
} = SocketTypeEnums;
const {
	START_FETCH_CONVERSATION,
	START_UPDATE_CONVERSATION_TEXT_SIZE,
	START_CREATE_NORMAL_REPLY_CONVERSATION,
	START_CREATE_QUICK_PATH_CONVERSATION,
	START_CREATE_SMART_REPLY_CONVERSATION,
	START_CLOSE_CONVERSATION,
	START_GRADE_CONVERSATION_SCORE,
	START_CLEAR_CONVERSATION_SESSION,
} = actionTypes;

export function getConversationEmitter(socket) {
	return function (store, action) {
		const { type } = action;

		if (type === START_FETCH_CONVERSATION) {
			socket.emit(CONVERSATION_COMMAND_GET, {
				messageId: CONVERSATION_COMMAND_GET,
			});
		}
	};
}

export function updateConversationTextSizeCommandUpdateEmitter(socket) {
	return function (store, action) {
		const { type, textSize } = action;

		if (type === START_UPDATE_CONVERSATION_TEXT_SIZE) {
			socket.emit(CONVERSATION_TEXT_SIZE_COMMAND_UPDATE, {
				messageId: CONVERSATION_TEXT_SIZE_COMMAND_UPDATE,
				textSize,
			});
		}
	};
}

export function createNormalReplayConversationEmitter(socket) {
	return function (store, action) {
		const { type } = action;

		if (type === START_CREATE_NORMAL_REPLY_CONVERSATION) {
			socket.emit(CONVERSATION_NORMAL_REPLY_COMMAND_CREATE, {
				messageId: CONVERSATION_NORMAL_REPLY_COMMAND_CREATE,
			});
		}
	};
}

export function createQuickPathConversationEmitter(socket) {
	return function (store, action) {
		const { type } = action;

		if (type === START_CREATE_QUICK_PATH_CONVERSATION) {
			socket.emit(CONVERSATION_QUICK_PATH_COMMAND_CREATE, {
				messageId: CONVERSATION_QUICK_PATH_COMMAND_CREATE,
			});
		}
	};
}

export function createSmartReplyConversationEmitter(socket) {
	return function (store, action) {
		const { type } = action;

		if (type === START_CREATE_SMART_REPLY_CONVERSATION) {
			socket.emit(CONVERSATION_SMART_REPLY_COMMAND_CREATE, {
				messageId: CONVERSATION_SMART_REPLY_COMMAND_CREATE,
			});
		}
	};
}

export function closeConversationEmitter(socket) {
	return function (store, action) {
		const { type, conversationId, isNavigatingHome } = action;

		if (type === START_CLOSE_CONVERSATION) {
			socket.emit(CONVERSATION_COMMAND_CLOSE, {
				messageId: CONVERSATION_COMMAND_CLOSE,
				conversationId,
				isNavigatingHome,
			});
		}
	};
}

export function gradeConversationScoreEmitter(socket) {
	return function (store, action) {
		const { type, score } = action;

		if (type === START_GRADE_CONVERSATION_SCORE) {
			socket.emit(CONVERSATION_SCORE_COMMAND_UPDATE, {
				messageId: CONVERSATION_SCORE_COMMAND_UPDATE,
				score,
			});
		}
	};
}

export function clearConversationSessionEmitter(socket) {
	return function (store, action) {
		const { type } = action;

		if (type === START_CLEAR_CONVERSATION_SESSION) {
			socket.emit(CONVERSATION_SESSION_COMMAND_CLEAR, {
				messageId: CONVERSATION_SESSION_COMMAND_CLEAR,
			});
		}
	};
}
